import {
  deletePortfolioAtPath,
  getPortfolioCountAtPath,
  loadPortfolioAtPath,
  loadPortfoliosAtPath,
  portfolioExistsAtPath,
  renamePortfolioAtPath,
  savePortfolioAtPath,
  updatePortfolioAtPath,
} from '../commonBlogUtils.js';

import { loadPortfolio as loadDraft, deletePortfolio as deleteDraft, savePortfolio as saveDraft } from './draftPortfolioUtils.js';
import { syncPublishedAssetVisibility } from './publishedAssetUtils.js';

export const togglePublished = async (userId, portfolioTitle) => {
  const isPublished = await portfolioExists(userId, portfolioTitle);

  if (isPublished) {
    const portfolioData = await loadPortfolio(userId, portfolioTitle);
    if (!portfolioData) {
      throw new Error('Published portfolio not found');
    }

    await saveDraft(userId, portfolioTitle, portfolioData);
    await deletePortfolio(userId, portfolioTitle);
    await syncPublishedAssetVisibility(userId);

    return false; // Now it's a draft
  }
  else {
    const portfolioData = await loadDraft(userId, portfolioTitle);
    if (!portfolioData) {
      throw new Error('Draft portfolio not found');
    }

    await savePortfolio(userId, portfolioTitle, portfolioData);
    await deleteDraft(userId, portfolioTitle);
    await syncPublishedAssetVisibility(userId);

    return true;
  }
}

export const rebuildVisibility = async (userId) =>
  syncPublishedAssetVisibility(userId);

export const savePortfolio = async (userId, portfolioTitle, blogData) => {
  await savePortfolioAtPath(['users', userId, 'published-portfolios'], portfolioTitle, blogData, 'Portfolio');
  await syncPublishedAssetVisibility(userId);
}

export const loadPortfolio = async (userId, portfolioTitle) =>
  loadPortfolioAtPath(['users', userId, 'published-portfolios'], portfolioTitle);

export const loadUserPortfolios = async (userId) =>
  loadPortfoliosAtPath(['users', userId, 'published-portfolios']);

export const deletePortfolio = async (userId, portfolioTitle) => {
  await deletePortfolioAtPath(['users', userId, 'published-portfolios'], portfolioTitle, 'Portfolio');
  await syncPublishedAssetVisibility(userId);
}
  
export const updatePortfolio = async (userId, portfolioTitle, updateData) =>
  updatePortfolioAtPath(['users', userId, 'published-portfolios'], portfolioTitle, updateData, 'Portfolio');

export const renamePortfolio = async (userId, oldTitle, newTitle) =>
  renamePortfolioAtPath(['users', userId, 'published-portfolios'], oldTitle, newTitle, 'Portfolio');

export const portfolioExists = async (userId, portfolioTitle) =>
  portfolioExistsAtPath(['users', userId, 'published-portfolios'], portfolioTitle);

export const getPortfolioCount = async (userId) =>
  getPortfolioCountAtPath(['users', userId, 'published-portfolios']);





